import { useApi } from "../../services/api/useApi";
import { url } from "../../services/api/url";

export const useServices = () => {
    const { get } = useApi();
    
    const getUserOverview = async () => {
        const userOverview = await get(url.users.me);
        return userOverview.data;
    };

    return {
        getUserOverview,
    };
}